import { useAuth } from '@/hooks/useAuth';
import { Permissions, type Permission } from '@/types';

interface JobTabsProps {
  activeTab: 'overview' | 'costs' | 'charges' | 'payments';
  onTabChange: (tab: 'overview' | 'costs' | 'charges' | 'payments') => void;
}

export function JobTabs({ activeTab, onTabChange }: JobTabsProps) {
  const { hasPermission } = useAuth();

  const allTabs: { id: 'overview' | 'costs' | 'charges' | 'payments'; label: string; permission?: Permission }[] = [
    { id: 'overview', label: 'Overview' },
    { id: 'costs', label: 'Costs', permission: Permissions.JobsCost },
    { id: 'charges', label: 'Charges', permission: Permissions.JobsCost },
    { id: 'payments', label: 'Payments', permission: Permissions.JobsCost },
  ];

  const tabs = allTabs.filter(tab => !tab.permission || hasPermission(tab.permission));

  return (
    <div className="border-b border-[#d9d9d9]">
      <nav className="flex gap-1" aria-label="Job tabs">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`px-4 py-2 text-sm font-medium rounded-t-lg transition-colors ${
              activeTab === tab.id
                ? 'bg-white text-[#0A0A9E] border-t-2 border-x border-[#d9d9d9] border-b-0'
                : 'bg-gray-50 text-gray-600 hover:text-gray-900 hover:bg-gray-100'
            }`}
            aria-current={activeTab === tab.id ? 'page' : undefined}
          >
            {tab.label}
          </button>
        ))}
      </nav>
    </div>
  );
}
